import { FC } from 'react';
import { UseFormRegister } from 'react-hook-form';
import { Switch } from '@chakra-ui/react';

import { CustomerFormFields } from 'page/CustomerPage/types/customerFormField';

type Props = {
  register: UseFormRegister<CustomerFormFields>;
  value: boolean;
};

/**
 * 顧客ステータスコントローラーのベースです
 */
export const StatusFormBase: FC<Props> = ({ register, value }) => (
  <Switch id="status" size="md" {...register('status')} isChecked={value} />
);
